import Swiper from 'swiper/bundle'
import { Pagination, Navigation, EffectFade, Autoplay } from 'swiper/modules'

export default class Testimonials {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    this.swiper = new Swiper(this.el.querySelector('.swiper'), {
      modules: [Pagination, Navigation, EffectFade, Autoplay],
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      autoplay: { delay: 4000, disableOnInteraction: false },
      pagination: {
        el: this.el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: this.el.querySelector('.testimonials--prev'),
        nextEl: this.el.querySelector('.testimonials--next'),
      },
    })
  }
}
